/**
 * Maps backend error messages to translated error messages
 * @param errorMessage - The error message from the backend API
 * @param t - The translation function from react-i18next
 * @returns The translated error message or the original message if no mapping exists
 */
export const mapBackendErrorToTranslation = (errorMessage: string, t: (key: string) => string): string => {
  // Map specific backend error messages to i18n keys
  const errorMappings: Record<string, string> = {
    'User with this email already exists': 'validation.emailAlreadyExists',
    'User with this national ID already exists': 'validation.nationalIdAlreadyExists',
    'NATIONAL_ID_ALREADY_MONITORED': 'validation.nationalIdAlreadyMonitored',
  };

  // Return translated message if mapping exists, otherwise return original message
  const translationKey = errorMappings[errorMessage];
  return translationKey ? t(translationKey) : errorMessage;
};